import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Button, Stack } from "@mui/material";
import { Colors } from "../../../../Styles/Colors";
import { ImagePaths } from "../../../../Utility/ImagePaths";
import { CommonGridToolBarWithFilterText } from "../../../../Components/Common Components/CommonComponents";
import ToastMsg from "../../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../Utility/API/Serviceurls";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { AmountFormat, CheckAccessFunc, formatDateAndTimeMeth2 } from "../../../../Components/CommonFunctions/CommonFunctions";

function MembershipReportsHome(props) {
    const { loggedData } = props
    const history = useHistory();
    const location = useLocation();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [PackageData, setPackagedata] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    let EditAccess = (CheckAccessFunc("Store", "Purchase", "Audit", null, "Tab")?.editAccess)


    useEffect(() => {
        getAuditList()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }


    const getAuditList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.MEMBERSHIP_MEMBER_REPORT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setPackagedata(response.data.data || [])
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const GetPrint = () => {
        try {
            RestAPIService.getAllPrint(Serviceurls.STORE_AUDIT_STOCK_HOME + `?export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const tableView = () => {
        try {
            const gridToolBar = () => {
                return (
                    <Box>
                        <CommonGridToolBarWithFilterText />
                    </Box>
                )
            }

            PackageData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                { field: 'sno', headerName: "S No", flex: 0.03, align: "center", headerAlign: "center" },
                {
                    field: "package_name", headerName: "Pakage Name", flex: 0.15,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.package_name ? params?.row?.package_name?.length > 30 ?
                        <Tooltip placement='top' title={params?.row?.package_name} arrow><div>{params?.row?.package_name.slice(0, 30) + "..."}</div></Tooltip> : params?.row?.package_name : "-"}</Box>)
                },
                {
                    field: "package_amount", headerName: "Package Amount", flex: 0.07, align: "center", headerAlign: "center",
                    renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.package_amount || 0)}</Box>)
                },
                {
                    field: "no_of_cards", headerName: "No Of Users", flex: 0.07, align: "center", headerAlign: "center",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.no_of_cards || 0}</Box>)
                },
                {
                    field: "action", headerName: "Action", flex: 0.03, align: "center", headerAlign: "center",
                    renderCell: (params) => (<Box component={'div'}>
                        <IconButton className='eMed_usrconf_btn' onClick={() => {
                            history.push({ pathname: '/FOReports/PatientReport/MembershipReport/CardWise', states: { PackageData : params?.row} })
                        }}>
                            <img src={ImagePaths.StoreViewButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                        </IconButton>
                    </Box>)
                },
            ];
            return (
                <Box sx={{ height: '77vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={PackageData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='standard'
                        disableSelectionOnClick
                        loading={isloader}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box display={'flex'} justifyContent={'flex-end'} flexDirection={'row'} alignItems={'center'}>
                {/* <Tooltip title={'Print'} placement="top">
                    <IconButton onClick={() => { GetPrint() }}          >
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
                    </IconButton>
                </Tooltip> */}
            </Box>
            <Box>
                {tableView()}
            </Box>
            {
                (errorMsg && errorMsgText) ?
                    <ToastMsg
                        severity={'error'}
                        msg={errorMsgText}
                        msgPop={msgClose}
                    />
                    : null}
            {
                (successMsg && successMsgText) ?
                    <ToastMsg
                        severity={'success'}
                        msg={successMsgText}
                        msgPop={msgClose}
                    />
                    : null
            }
        </Box>
    );
};

export default MembershipReportsHome;
